<template>
  <div class="OLegend">
    <h4>Legend</h4>
    <ul>
      <li
          v-for="(header, index) in pageHeaders"
          :key="index"
          @click="() => scrollIntoView(header)"
          class="is-clickable as-link p-4"
      >
        {{ header.innerText }}
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.OLegend {
  position: fixed;
  top: 30vh;
  left: 0;
  z-index: 10;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OLegend extends Vue {
  pageHeaders: HTMLElement[] = [];

  mounted () {
    this.setPageHeadings();
  }

  setPageHeadings () {
    document.querySelectorAll('h1, h2, h3').forEach((e) => {
      if (e.innerHTML.trim() !== 'Liffery') {
        this.pageHeaders.push(e as HTMLElement);
      }
    });
  }

  scrollIntoView (e: HTMLElement) {
    const rect = e.getBoundingClientRect();
    window.scrollTo({
      top: rect.y,
      behavior: 'smooth'
    });
  }
}
</script>
